import { render } from "./EditArticles.vue?vue&type=template&id=254c060a"
import script from "./EditArticles.vue?vue&type=script&lang=js"
export * from "./EditArticles.vue?vue&type=script&lang=js"

import exportComponent from "E:\\moneyman\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__